import { useEffect } from "react";

import FormGeneratorSection from "../../components/Survey/FormGeneratorSection";

import CONFIG from "../../utils/config";

const FormGeneratorPageMobile = () => {
  useEffect(() => {
    let sendHeight = setInterval(() => {
      let obj = {
        method: "height",
        value: document.getElementById("root").scrollHeight + 25,
      };
      console.log("height: ", obj);
      window.parent.postMessage(obj, CONFIG.API_URL_BROKER_ADMIN);
    }, 3000);
    return () => {
      clearInterval(sendHeight);
    };
  }, []);

  return (
    <>
      <FormGeneratorSection isMobile={true} />
    </>
  );
};

export default FormGeneratorPageMobile;
